import getStatementRowsMap from "./getStatementRowsMap";

export default function findStatementRowById(statement: Statement, rowId: string): StatementRow|undefined {
    const rowsById = getStatementRowsMap(statement);
    return rowsById.get(rowId);
}
